import { render, staticRenderFns } from "./DiagnosticCard.vue?vue&type=template&id=d7faa444&"
import script from "./DiagnosticCard.vue?vue&type=script&lang=ts&"
export * from "./DiagnosticCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports